import { Colors } from '@/constants/theme';
import { ReactNode } from 'react';
import { StyleSheet } from 'react-native';
import { View } from './tw-wrappers';

export function Card({
  children,
  backgroundColor,
  borderColor,
  borderWidth,
  className,
  disableShadow = false,
}: {
  children: ReactNode;
  backgroundColor?: string;
  borderColor?: string;
  borderWidth?: number;
  className?: string;
  disableShadow?: boolean;
}) {
  return (
    <View
      className={className}
      style={[
        styles.card,
        backgroundColor ? { backgroundColor } : { backgroundColor: '#ffffff' },
        borderColor ? { borderColor } : null,
        borderWidth ? { borderWidth } : null,
        disableShadow ? styles.shadowDisabled : null,
      ]}>
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    borderRadius: 16,
    padding: 20,
    borderWidth: 1,
    borderColor: 'rgba(0,0,0,0.05)',
    shadowColor: Colors.light.shadow,
    shadowOffset: { width: 4, height: 4 },
    shadowOpacity: 1,
    shadowRadius: 0,
    elevation: 2,
    gap: 12,
    position: 'relative',
  },
  shadowDisabled: {
    shadowColor: 'transparent',
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0,
    shadowRadius: 0,
    elevation: 0,
  }
});

